import { useEffect, useState } from "react";
export type ViewportSize = {
  height: number;
  width: number;
};
export const useViewportSize = () => {
  const [viewportSize, setViewportSize] = useState<ViewportSize>({
    height: window.innerHeight,
    width: window.innerWidth
  });
  useEffect(() => {
    const handleResize = () => {
      setViewportSize({
        height: window.innerHeight,
        width: window.innerWidth
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  return viewportSize;
};
export default useViewportSize;
export { mockWindowResizeTo } from "./mockWindowResizeTo";